/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Investment_BuyOrderStatus {
  ACCEPTED = "ACCEPTED",
  CANCELED_BY_ADMIN = "CANCELED_BY_ADMIN",
  CANCELED_BY_USER = "CANCELED_BY_USER",
  CREATED = "CREATED",
  FAILED_CANCEL = "FAILED_CANCEL",
  FAILED_CREATE = "FAILED_CREATE",
  FILLED = "FILLED",
  LOCKED = "LOCKED",
  POSTPONED = "POSTPONED",
  PREPARED_TO_CANCEL = "PREPARED_TO_CANCEL",
  REJECTED_AND_ARCHIVED = "REJECTED_AND_ARCHIVED",
  REJECTED_BY_ADMIN = "REJECTED_BY_ADMIN",
  REJECTED_BY_EXCHANGE = "REJECTED_BY_EXCHANGE",
  REJECTED_NO_FUNDS = "REJECTED_NO_FUNDS",
  SEALED = "SEALED",
}

export enum Investment_IdeaCategory {
  BONDS = "BONDS",
  CRYPTO = "CRYPTO",
  ICO = "ICO",
  ICO_PRESALE = "ICO_PRESALE",
  IPO = "IPO",
  OTC = "OTC",
  PRE_IPO = "PRE_IPO",
  SPAC = "SPAC",
  STOCKS = "STOCKS",
  STRATEGY_PACK = "STRATEGY_PACK",
}

export enum Investment_IdeaType {
  BUY_AND_HOLD = "BUY_AND_HOLD",
  LIMITED = "LIMITED",
  UNLIMITED = "UNLIMITED",
}

export enum Investment_PositionSellStatus {
  ACCEPTED = "ACCEPTED",
  ACKNOWLEDGED_BY_USER = "ACKNOWLEDGED_BY_USER",
  CANCELED_BY_USER = "CANCELED_BY_USER",
  CREATED = "CREATED",
  FILLED = "FILLED",
  REJECTED = "REJECTED",
}

export enum Investment_RiskLevel {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum Investment_UnitBillingPeriod {
  DAY = "DAY",
  MONTH = "MONTH",
  WEEK = "WEEK",
}

export enum Lab_CommonProductType {
  BUY_AND_HOLD = "BUY_AND_HOLD",
  LIMITED = "LIMITED",
  STOCKS = "STOCKS",
  UNLIMITED = "UNLIMITED",
}

/**
 * PHONE - 
 * EMAIL - 
 */
export enum SendingMethod {
  EMAIL = "EMAIL",
  PHONE = "PHONE",
}

export enum SortDirection {
  asc = "asc",
  desc = "desc",
}

/**
 * CREATED - User sent order
 * CREATED_NO_EXCHANGE - Admin created order for user
 * FAILED_ACCEPT - Order is saved but there were some issues with billing processing
 * ACCEPTED - Billing request was successful, request amount of money reserved on INVESTMENT_PREPARED account
 * ACCEPTED_NO_EXCHANGE - Billing request was successful, request amount of money reserved on INVESTMENT_PREPARED account
 * LOCKED - Exchange order created or manually accepted by admin (after successful
 * billing request), we are waiting for response
 * FILLED - Order filled after exchange order filled on executionAmount
 * REJECTED - Exchange order rejected for some reason
 * REJECTED_BY_ADMIN - Order has been rejected by admin
 * REJECTED_AND_ARCHIVED - Order moved to archive by user after it has been rejected by exchange or by admin.
 * FAILED_PROCESSING - Billing operation failed for fill up money position investment operation
 */
export enum StockBuyOrderStatus {
  ACCEPTED = "ACCEPTED",
  ACCEPTED_NO_EXCHANGE = "ACCEPTED_NO_EXCHANGE",
  CREATED = "CREATED",
  CREATED_NO_EXCHANGE = "CREATED_NO_EXCHANGE",
  FAILED_ACCEPT = "FAILED_ACCEPT",
  FAILED_PROCESSING = "FAILED_PROCESSING",
  FILLED = "FILLED",
  LOCKED = "LOCKED",
  REJECTED = "REJECTED",
  REJECTED_AND_ARCHIVED = "REJECTED_AND_ARCHIVED",
  REJECTED_BY_ADMIN = "REJECTED_BY_ADMIN",
}

export enum Stocks_BuyOrderStatus {
  ACCEPTED = "ACCEPTED",
  ACCEPTED_NO_EXCHANGE = "ACCEPTED_NO_EXCHANGE",
  CREATED = "CREATED",
  CREATED_NO_EXCHANGE = "CREATED_NO_EXCHANGE",
  FAILED_ACCEPT = "FAILED_ACCEPT",
  FAILED_PROCESSING = "FAILED_PROCESSING",
  FILLED = "FILLED",
  LOCKED = "LOCKED",
  REJECTED = "REJECTED",
  REJECTED_AND_ARCHIVED = "REJECTED_AND_ARCHIVED",
  REJECTED_BY_ADMIN = "REJECTED_BY_ADMIN",
}

export enum Stocks_PositionHistoryType {
  BUY = "BUY",
  SELL = "SELL",
}

export enum Stocks_StockRisk {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum Stocks_StockStatus {
  HIDDEN = "HIDDEN",
  PUBLISHED = "PUBLISHED",
}

export enum Stocks_StockType {
  ETF = "ETF",
  STOCKS = "STOCKS",
}

/**
 * OTP_DISABLED - 2FA отключена
 * OTP_GA - Подтверждение входа с помощью Google Authenticator
 * OTP_EMAIL - Подтверждение входа с помощью кода из Email
 */
export enum UserDirectoryOTPType {
  OTP_DISABLED = "OTP_DISABLED",
  OTP_EMAIL = "OTP_EMAIL",
  OTP_GA = "OTP_GA",
}

export interface BuyOrderCreateRequest {
  price: MoneyInput;
  quantity: number;
  stockId: number;
}

export interface Lab_CreateOrderRequest {
  amount: Lab_MoneyInput;
  ideaId: number;
}

export interface Lab_MoneyInput {
  currency: string;
  exp?: number | null;
  value: number;
}

/**
 * Money
 */
export interface MoneyInput {
  currency: string;
  exp?: number | null;
  value: number;
}

export interface PasswordResetStartRequest {
  email: string;
  locale?: string | null;
  origin?: string | null;
  recaptchaResponse?: string | null;
  registrationType?: string | null;
}

export interface Sort {
  direction: SortDirection;
  property: string;
}

export interface Stocks_MoneyInput {
  currency: string;
  exp?: number | null;
  value: number;
}

export interface Stocks_PaginationArgs {
  page?: number | null;
  size?: number | null;
  sort?: Sort | null;
}

export interface Stocks_StockListFilter {
  capitalizationFrom?: Stocks_MoneyInput | null;
  capitalizationTo?: Stocks_MoneyInput | null;
  industry?: string | null;
  risk?: Stocks_StockRisk | null;
  searchString?: string | null;
  sector?: string | null;
  type?: Stocks_StockType | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
